import { Footer } from "./html/Footer";
import Header from "./html/Header";
import { getMessage } from "../../utils/getMessage";
import { getImage } from "../../utils/getImage";

export const NotAvailableComponent = (props) => {
  const { msgError, icon, icon2, msj } = props;
  const { errMsj, intCod } = msgError;
  
  return (
    <>
      {/* <Header /> */}
      <form className="rating" id="formSurvey">
        <div className="containerMessage notAvailContainer">
        <div className="separatorBlue"></div>
          {/* <p className='iconoMsj'>{msgError === "Esta encuesta ya está respondida" ? "☑" : "X"}</p> */}
          {/* <h4>{errMsj}</h4> */}
          {icon &&<img className="notavail-img1" src={icon} alt="imagen"></img>}
          {icon2 &&<img className="notavail-img2" src={icon2} alt="imagen"></img>}
          {msj && <h1 className="notavail-msj" dangerouslySetInnerHTML={{ __html: msj } } />}
          <h1 className="notavail-msj" dangerouslySetInnerHTML={{ __html: getMessage(intCod)==''?errMsj: getMessage(intCod)} } />
        </div>
      </form>
      {/* <Footer  img1={getImage(4)} msg={getMessage(19)} /> */}
    </>
  );
};
